const Terms = (history: any, location: any) => {
    const heading1 = {
        fontSize: "2rem",
        textAlign: "center" as const,
        marginBottom: "10px",
        color: "#111",
    };

    const heading2 = {
        fontSize: "1.4rem",
        marginTop: "30px",
        borderBottom: "2px solid #eee",
        paddingBottom: "5px",
        color: "#111",
    };

    const heading3 = {
        fontSize: "1.1rem",
        marginTop: "20px",
        color: "#222",
    };

    const paragraph = {
        margin: "10px 0",
    };

    const effectiveDate = {
        textAlign: "center" as const,
        fontSize: "0.95rem",
        color: "#666",
        marginBottom: "20px",
    };

    const contactBox = {
        marginTop: "30px",
        padding: "15px",
        background: "#f9f9f9",
        borderRadius: "5px",
        border: "1px solid #eee",
    };

    return (
        <div style={{ width: '90%', margin: '0 auto', padding: '40px 0', color: '#171717' }}>
            <h1 style={heading1}>Terms and Conditions</h1>
            <p style={effectiveDate}>
                <strong>Effective Date:</strong> 01-09-2024
            </p>

            <p style={paragraph}>
                Welcome to <strong>SNAPWIZ</strong>, operated by{" "}
                <strong>Shah Eternalgraphers Private Limited</strong>. By booking our
                services via the SNAPWIZ platform, you agree to the following terms and
                conditions:
            </p>

            <h2 style={heading2}>Eligibility & Account Registration</h2>
            <p style={paragraph}>
                You must be at least 18 years old and legally capable of entering into
                binding contracts. By registering, you represent that you meet these
                criteria.
            </p>
            <p style={paragraph}>
                To access our services, users must register and create an account. You
                agree to provide accurate and complete information and to keep this
                information updated.
            </p>

            <h2 style={heading2}>SECTION 1: Refund and Liability Policy</h2>
            <h3 style={heading3}>1.1 No Refund Policy</h3>
            <p style={paragraph}>
                All bookings made through the SNAPWIZ platform are final. Refunds are
                permitted only in limited situations as described below.
            </p>

            <h3 style={heading3}>1.2 Data Loss or Corruption</h3>
            <p style={paragraph}>
                While SNAPWIZ takes reasonable technical precautions to protect your
                data, we do not guarantee against data loss or corruption. In the event
                of irrecoverable loss directly caused by SNAPWIZ or its representatives,
                liability is strictly limited to a refund of the shoot booking amount.
                We do not assume liability for event-related costs or consequential
                damages.
            </p>

            <h3 style={heading3}>1.3 Missing Data</h3>
            <p style={paragraph}>
                If data is reasonably determined to be missing due to SNAPWIZ's error, a
                refund may be granted up to the order amount. No additional compensation
                or liability for client event costs shall be entertained.
            </p>

            <h3 style={heading3}>1.4 Final Scope of Refund</h3>
            <p style={paragraph}>
                Under all circumstances, SNAPWIZ total liability is limited to the shoot
                order amount paid. Any losses, damages, or costs beyond the shoot value
                (including indirect, incidental, or event-related expenses) are
                expressly disclaimed.
            </p>

            <h2 style={heading2}>SECTION 2: Payment Policy</h2>
            <h3 style={heading3}>2.1 Accepted Payment Methods</h3>
            <p style={paragraph}>
                Payments are accepted through secure gateways such as credit/debit
                cards, UPI, mobile wallets, and bank transfers. We do not accept cash,
                cash deposits, or hand payments.
            </p>

            <h3 style={heading3}>2.2 Payment Confirmation</h3>
            <p style={paragraph}>
                Bookings are only confirmed upon successful receipt of payment through
                SNAPWIZ authorized payment portal.
            </p>

            <h2 style={heading2}>SECTION 3: Location Selection & Permissions</h2>
            <h3 style={heading3}>3.1 Client Responsibility</h3>
            <p style={paragraph}>
                Clients must select and obtain permissions for shooting locations.
                SNAPWIZ is not responsible for permissions, permits, or access issues.
            </p>

            <h3 style={heading3}>3.2 Legal & Safety Considerations</h3>
            <p style={paragraph}>
                Any legal issues arising from unauthorized use of a location are the
                sole responsibility of the client. If access is denied or issues occur
                on-site, SNAPWIZ disclaims any liability.
            </p>

            <h3 style={heading3}>3.3 Photographer Safety</h3>
            <p style={paragraph}>
                Photographers (Snapmasters) must not be taken to private rooms or areas
                with valuable items. SNAPWIZ is not liable for any theft, loss, or
                incidents in such cases. If a shoot is cancelled for safety concerns, a
                full refund of the order amount will be provided.
            </p>

            <h2 style={heading2}>SECTION 4: Direct Bookings Outside SNAPWIZ</h2>
            <h3 style={heading3}>4.1 Unauthorized Engagements</h3>
            <p style={paragraph}>
                If a customer contacts a Snapmaster directly and not via the SNAPWIZ
                platform, SNAPWIZ disclaims all responsibility. Legal action may be
                taken against both parties.
            </p>

            <h2 style={heading2}>SECTION 5: Bad Weather & Rescheduling Policy</h2>
            <h3 style={heading3}>5.1 Weather-Related Rescheduling</h3>
            <p style={paragraph}>
                In case of adverse weather conditions, SNAPWIZ will offer to reschedule
                the shoot at no extra cost. Final decision on shoot safety rests with
                the SNAPWIZ team.
            </p>

            <h2 style={heading2}>SECTION 6: Early Departure</h2>
            <h3 style={heading3}>6.1 Completed Sessions</h3>
            <p style={paragraph}>
                If the session concludes early due to efficient completion, it shall be
                deemed fully completed. No refund or rescheduling will be offered.
            </p>

            <h2 style={heading2}>SECTION 7: Delays by Photographer (Snapmaster)</h2>
            <h3 style={heading3}>7.1 Photographer Delay</h3>
            <p style={paragraph}>
                If a Snapmaster arrives late due to valid reasons (traffic, health,
                equipment), additional time will be added at no cost. If the client opts
                to cancel, a refund up to the order amount will be processed. SNAPWIZ is
                not responsible for event-related losses.
            </p>

            <h2 style={heading2}>SECTION 8: Image Delivery</h2>
            <h3 style={heading3}>8.1 Delivery Timeline</h3>
            <p style={paragraph}>
                Edited images will be delivered within 48 working hours (Mon-Fri, 10 AM
                – 7 PM). Weekends and holidays are excluded.
            </p>
            <h3 style={heading3}>8.2 Delays</h3>
            <p style={paragraph}>
                In case of unexpected delays, clients will be informed with an updated
                timeline.
            </p>

            <h2 style={heading2}>SECTION 9: Data Usage & Copyright</h2>
            <h3 style={heading3}>9.1 Ownership</h3>
            <p style={paragraph}>
                All photos, videos, and audio captured by SNAPWIZ remain the intellectual property of Shah Eternalgraphers Pvt. Ltd.
            </p>
            <h3 style={heading3}>9.2 Usage Consent</h3>
            <p style={paragraph}>
                By booking our services, you grant SNAPWIZ the right to use the content for promotional and educational purposes unless a written opt-out is provided.
            </p>
            <h3 style={heading3}>9.3 Third-Party Consent</h3>
            <p style={paragraph}>
                Clients are responsible for securing permissions from all individuals featured in the shoot.
            </p>

            {/* Continue with Sections 10–16 similarly */}

            <div style={contactBox}>
                <h3 style={heading3}>Contact</h3>
                <p style={paragraph}>
                    Email: <a href="mailto:contact@snapwiz.in">contact@snapwiz.in</a>
                </p>
                <p style={paragraph}>
                    By booking any service via the SNAPWIZ platform, the client acknowledges, understands,
                    and agrees to abide by the terms stated herein.
                </p>
                <b style={{ ...paragraph, textDecoration: 'underline' }}>Team SNAPWIZ</b>
            </div>
        </div>
    )
}

export default Terms;